import React from "react";
import "./css/AuthContainer.css";

function AuthContainer({ children }) {
  return (
    <div className="auth">
      <main className="auth-main">
        <div className="auth-right">{children}</div>
      </main>
    </div>
  );
}

export default AuthContainer;
